import D1 from '../../components/ExcerciseTypes/Design/TypeIn';

const json = {

  1: { // Exercise num
    unit: 'Unit 3',
    id: 'WB3-U3-P26-E1',
    audio: '',
    video: '',
    // maxLength: 3,
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page26/E1/Key/Key.PNG',
    //recorder: true,
    isAllowSubmit: true,
    questionImage: [ // Row

      [
        // Column1
        { url: 'img/FriendsPlus/Page26/E1/1.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page26/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page26/E1/3.jpg', input: true, answer: "That is" },
        { url: 'img/FriendsPlus/Page26/E1/4.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page26/E1/5.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page26/E1/6.jpg' },
        { url: 'img/FriendsPlus/Page26/E1/7.jpg', input: true, answer: "This is" },
        { url: 'img/FriendsPlus/Page26/E1/8.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page26/E1/9.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page26/E1/10.jpg' },
        { url: 'img/FriendsPlus/Page26/E1/11.jpg', input: true, answer: "these are" },
        { url: 'img/FriendsPlus/Page26/E1/12.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page26/E1/13.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page26/E1/14.jpg' },
        { url: 'img/FriendsPlus/Page26/E1/15.jpg', input: true, answer: "Those are" },
        { url: 'img/FriendsPlus/Page26/E1/16.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page26/E1/17.jpg' },
      ],
    ],
  },
  2: { // Exercise num
    unit: 'Unit 3',
    id: 'WB1-U3-P26-E2',
    audio: '',
    video: '',
    component: D1,
    checkDuplicated: true,
    exerciseKey: 'img/FriendsPlus/Page26/E2/Key/Key.PNG',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page26/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page26/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page26/E2/3.jpg', input: true, answer: "chicken/salad/noodles/pizza" },
        { url: 'img/FriendsPlus/Page26/E2/4.jpg' },
        { url: 'img/FriendsPlus/Page26/E2/5.jpg', input: true, answer: "computer/board/coat hooks/posters" },
        { url: 'img/FriendsPlus/Page26/E2/6.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page26/E2/7.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page26/E2/8.jpg' },
        { url: 'img/FriendsPlus/Page26/E2/9.jpg', input: true, answer: "forty/thirty/eighty" },
        { url: 'img/FriendsPlus/Page26/E2/10.jpg' },
        { url: 'img/FriendsPlus/Page26/E2/11.jpg', input: true, answer: "chicken/salad/noodles/pizza" },
        { url: 'img/FriendsPlus/Page26/E2/12.jpg' },
        { url: 'img/FriendsPlus/Page26/E2/13.jpg', input: true, answer: "computer/board/coat hooks/posters" },
        { url: 'img/FriendsPlus/Page26/E2/14.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page26/E2/15.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page26/E2/16.jpg' },
        { url: 'img/FriendsPlus/Page26/E2/17.jpg', input: true, answer: "forty/thirty/eighty" },
        { url: 'img/FriendsPlus/Page26/E2/18.jpg' },
        { url: 'img/FriendsPlus/Page26/E2/19.jpg', input: true, answer: "chicken/salad/noodles/pizza" },
        { url: 'img/FriendsPlus/Page26/E2/20.jpg' },
        { url: 'img/FriendsPlus/Page26/E2/21.jpg', input: true, answer: "computer/board/coat hooks/posters" },
        { url: 'img/FriendsPlus/Page26/E2/22.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page26/E2/23.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page26/E2/24.jpg' },
        { url: 'img/FriendsPlus/Page26/E2/25.jpg', input: true, answer: "forty/thirty/eighty" },
        { url: 'img/FriendsPlus/Page26/E2/26.jpg' },
        { url: 'img/FriendsPlus/Page26/E2/27.jpg', input: true, answer: "chicken/salad/noodles/pizza" },
        { url: 'img/FriendsPlus/Page26/E2/28.jpg' },
        { url: 'img/FriendsPlus/Page26/E2/29.jpg', input: true, answer: "computer/board/coat hooks/posters" },
        { url: 'img/FriendsPlus/Page26/E2/30.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page26/E2/31.jpg' },
      ],
    ],
  },

}

export default json;